import { Component, Provide, Vue } from 'vue-property-decorator';


@Component({})
export default class Clerk extends Vue {

}
